import apiClient from '../apiClient';
import PagesController from '@/controllers/PagesController';

export const getPageByCode = async (code) => {
  try {
    const response = await apiClient.get(`${PagesController.PageByCode}`, {
      params: { code }
    });
    return response.data; 
  } catch (error) {
   //alert( error);
    throw error; 
  }
};

export const whatTOGet = async () => {
    try {
    const response = await apiClient.get(`Pages/what-you-get`);
    return response.data; 
  } catch (error) {
   //alert( error);
    throw error; 
  }
}
